// Copyright 2026 Sorama B.V

import { UnitType } from "units/Unit";
import { CompositeUnit } from "./CompositeUnit";
import { Mass } from "./Mass";
import { Time } from "./Time";

export class MassFlow extends UnitType {
    public static override typeName = "MassFlow";

    public static gramsPerHour: CompositeUnit = new CompositeUnit(Mass.gram, Time.hour, MassFlow, {
        aliases: ["g/hour", "g/hr", "g/h"],
    });
}
